// libs
import React from 'react';
import PropTypes from 'prop-types';

// Component
import CardSlider from '../../../cards/cardSlider/CardSlider';

function Partners(props) {
  const {
    partners,
  } = props;
  const sliderSettings = {
    settings: {
      arrows: true,
      dots: false,
      slidesToShow: 7,
      infinite: false,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 1120,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 416,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
          },
        },
      ],
    },
  };
  return (
    <div className="flexible-content__item flexible-content__partners">
      {partners &&
      <CardSlider {...sliderSettings}>
        {partners.map((partner) =>
          <li key={partner.partner_name}>
            {partner.partner_website ?
              <a
                href={partner.partner_website.url}
                target={partner.partner_website.target}
                title={partner.partner_website.title}
              >
                {partner.partner_image ?
                  <img
                    src={partner.partner_image.sizes.large}
                    alt={partner.partner_name}
                  />
                  :
                  partner.partner_name
                }
              </a>
              :
              <React.Fragment>
                {partner.partner_image &&
                <img
                  src={partner.partner_image.sizes.large}
                  alt={partner.partner_name}
                />
                }
              </React.Fragment>
            }
          </li>,
        )}
      </CardSlider>
      }
    </div>
  );
}

Partners.propTypes = {
  partners: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Partners;



// WEBPACK FOOTER //
// ./src/app/components/pages/default/flexibleContents/Partners.js